import React, { useState } from "react";
import { Row, Col, Input, Select, Switch, Button, Empty } from "antd";
import { CloseCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";

const { Option } = Select;

const Step2CheckoutSettings = ({ wizardData, setWizardData }) => {
  const [errorField, setErrorField] = useState([]);

  const handleChange = (field, value) => {
    setWizardData({ ...wizardData, [field]: value });
    if (errorField.includes(field)) {
      setErrorField(errorField.filter((x) => x !== field));
    }
  };

  const onAddCode = () => {
    const tmpList = [...wizardData.discodeList];
    const oneCode = {
      text: "",
      percentage: "",
      amount: "",
      free: true,
      visible: 1,
      type: "single",
      row_index: "",
      multipleList: [2, 3, 4, 5, 6],
    };
    tmpList.push(oneCode);
    setWizardData({ ...wizardData, discodeList: tmpList });
  };

  const handleCodeChange = (index, field, value) => {
    const tmpCodeList = [...wizardData.discodeList];
    tmpCodeList[index][field] = value;
    setWizardData({ ...wizardData, discodeList: tmpCodeList });

    // Clear errors for this discount code field
    const errorKey = index + field;
    if (errorField.includes(errorKey)) {
      setErrorField(errorField.filter((x) => x !== errorKey));
    }
  };

  const handleCodeRemove = (index) => {
    const tmpCodeList = [...wizardData.discodeList];
    tmpCodeList[index].visible = 0;
    setWizardData({ ...wizardData, discodeList: tmpCodeList });
  };

  return (
    <div className="wizard-step-card">
      <h3 className="wizard-step-title">Checkout Settings</h3>
      <p className="wizard-step-description">
        Configure payment processing and discount codes for this registration.
      </p>

      <Row gutter={[16, 24]}>
        <Col xs={24} sm={12}>
          <div className="wizard-form-label">
            Merchant <span style={{ color: "red" }}>*</span>
            <span style={{ fontSize: 11, color: "#999", marginLeft: 8 }}>merchant</span>
          </div>
          <Select
            showSearch
            placeholder="Select payment processor"
            className={
              errorField.includes("merchant")
                ? "common-select-error"
                : "common-select"
            }
            value={wizardData.merchant}
            onChange={(v) => handleChange("merchant", v)}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="stax">Stax</Option>
            <Option value="forte">Forte</Option>
          </Select>
        </Col>

        <Col xs={24} sm={12}>
          <div className="wizard-form-label">
            Credit Card Fee <span style={{ color: "red" }}>*</span>
            <span style={{ fontSize: 11, color: "#999", marginLeft: 8 }}>credit_fee</span>
          </div>
          <Input
            type="number"
            step={0.01}
            value={wizardData.credit_fee}
            placeholder="2.9"
            suffix="%"
            className={
              errorField.includes("credit_fee")
                ? "common-input-error"
                : "common-input"
            }
            onChange={(e) => handleChange("credit_fee", e.target.value)}
          />
        </Col>

        <Col xs={24} sm={12}>
          <div className="wizard-form-label">
            Debit Card Fee <span style={{ color: "red" }}>*</span>
            <span style={{ fontSize: 11, color: "#999", marginLeft: 8 }}>debit_fee</span>
          </div>
          <Input
            type="number"
            step={0.01}
            value={wizardData.debit_fee}
            placeholder="1.5"
            suffix="%"
            className={
              errorField.includes("debit_fee")
                ? "common-input-error"
                : "common-input"
            }
            onChange={(e) => handleChange("debit_fee", e.target.value)}
          />
        </Col>

        <Col xs={24} sm={12}>
          <div className="wizard-form-label">
            Allow eCheck Payments
            <span style={{ fontSize: 11, color: "#999", marginLeft: 8 }}>echeck_fee</span>
          </div>
          <div>
            <Switch
              checked={wizardData.allow_echeck}
              onChange={(checked) => handleChange("allow_echeck", checked)}
              style={{ marginBottom: 10 }}
            />
            <span style={{ marginLeft: 12 }}>
              {wizardData.allow_echeck ? "Enabled" : "Disabled"}
            </span>
          </div>
        </Col>

        {wizardData.allow_echeck && (
          <Col xs={24} sm={12}>
            <div className="wizard-form-label">
              eCheck Fee <span style={{ color: "red" }}>*</span>
              <span style={{ fontSize: 11, color: "#999", marginLeft: 8 }}>echeck_fee</span>
            </div>
            <Input
              type="number"
              step={0.01}
              value={wizardData.echeck_fee}
              placeholder="5.00"
              prefix="$"
              suffix="USD"
              className={
                errorField.includes("echeck_fee")
                  ? "common-input-error"
                  : "common-input"
              }
              onChange={(e) => handleChange("echeck_fee", e.target.value)}
            />
          </Col>
        )}
      </Row>

      <Row gutter={[16, 24]} style={{ marginTop: 24 }}>
        <Col xs={24} sm={12}>
          <div className="wizard-form-label">
            Allow Manual Payments
            <span style={{ fontSize: 11, color: "#999", marginLeft: 8 }}>allow_manual_payments</span>
          </div>
          <div>
            <Switch
              checked={wizardData.allow_manual_payments}
              onChange={(checked) => handleChange("allow_manual_payments", checked)}
              style={{ marginBottom: 10 }}
            />
            <span style={{ marginLeft: 12 }}>
              {wizardData.allow_manual_payments ? "Enabled" : "Disabled"}
            </span>
          </div>
          <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>
            Allow users to submit registration and pay later with cash or check
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="wizard-form-label">
            Email Invoices to Admin
            <span style={{ fontSize: 11, color: "#999", marginLeft: 8 }}>email_invoices_to_admin</span>
          </div>
          <div>
            <Switch
              checked={wizardData.email_invoices_to_admin}
              onChange={(checked) => handleChange("email_invoices_to_admin", checked)}
              style={{ marginBottom: 10 }}
            />
            <span style={{ marginLeft: 12 }}>
              {wizardData.email_invoices_to_admin ? "Enabled" : "Disabled"}
            </span>
          </div>
          <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>
            Send a copy of all invoices to the admin email address
          </div>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
        <Col>
          <div className="wizard-form-label">Discount Codes</div>
        </Col>
        <Col>
          <Button onClick={onAddCode} type="dashed">
            Add Discount Code
          </Button>
        </Col>
      </Row>

      {wizardData?.discodeList && wizardData.discodeList.length > 0 ? (
        <div style={{ marginTop: 16 }}>
          {wizardData.discodeList.map((x, index) => {
            if (x.visible === 1) {
              return (
                <Row
                  key={index}
                  gutter={[16, 16]}
                  style={{
                    marginTop: 10,
                    padding: 16,
                    background: "#fafafa",
                    borderRadius: 4,
                  }}
                  align="bottom"
                >
                  <Col xs={24} sm={5}>
                    <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                      Code Type*
                    </div>
                    <Select
                      value={x.type}
                      className={
                        errorField.includes(index + "type")
                          ? "common-select-error"
                          : "common-select"
                      }
                      onChange={(v) => handleCodeChange(index, "type", v)}
                    >
                      <Option value="single">Discount</Option>
                      <Option value="multiple">Multiple Participants</Option>
                    </Select>
                  </Col>

                  {x.type === "single" ? (
                    <Col xs={24} sm={5}>
                      <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                        Code Text*
                      </div>
                      <Input
                        value={x.text}
                        placeholder="SUMMER2024"
                        className={
                          errorField.includes(index + "text")
                            ? "common-input-error"
                            : "common-input"
                        }
                        onChange={(e) =>
                          handleCodeChange(index, "text", e.target.value)
                        }
                      />
                    </Col>
                  ) : (
                    <Col xs={24} sm={5}>
                      <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                        # of Participants*
                      </div>
                      <Select
                        value={x.row_index}
                        placeholder="Select"
                        className={
                          errorField.includes(index + "row_index")
                            ? "common-select-error"
                            : "common-select"
                        }
                        onChange={(v) =>
                          handleCodeChange(index, "row_index", v)
                        }
                      >
                        {x.multipleList.map((row, rowKey) => (
                          <Option value={row} key={rowKey}>
                            {row}
                          </Option>
                        ))}
                      </Select>
                    </Col>
                  )}

                  <Col xs={24} sm={4}>
                    <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                      Percentage
                    </div>
                    <Input
                      value={x.percentage}
                      type="number"
                      placeholder="10"
                      suffix="%"
                      className={
                        errorField.includes(index + "percentage")
                          ? "common-input-error"
                          : "common-input"
                      }
                      onChange={(e) =>
                        handleCodeChange(index, "percentage", e.target.value)
                      }
                    />
                  </Col>

                  <Col xs={24} sm={4}>
                    <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                      Amount
                    </div>
                    <Input
                      value={x.amount}
                      type="number"
                      placeholder="50"
                      prefix="$"
                      suffix="USD"
                      className={
                        errorField.includes(index + "amount")
                          ? "common-input-error"
                          : "common-input"
                      }
                      onChange={(e) =>
                        handleCodeChange(index, "amount", e.target.value)
                      }
                    />
                  </Col>

                  <Col xs={12} sm={3}>
                    <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                      Free
                    </div>
                    <Switch
                      checkedChildren="Free"
                      unCheckedChildren="Non"
                      checked={x.free}
                      style={{ marginBottom: 10 }}
                      onChange={(e) => handleCodeChange(index, "free", e)}
                    />
                  </Col>

                  <Col xs={12} sm={2} style={{ textAlign: "right" }}>
                    <CloseCircleOutlined
                      style={{
                        color: "red",
                        marginBottom: 15,
                        cursor: "pointer",
                        fontSize: 18,
                      }}
                      onClick={() => handleCodeRemove(index)}
                    />
                  </Col>
                </Row>
              );
            }
            return null;
          })}
        </div>
      ) : (
        <Empty description="No discount codes added" style={{ marginTop: 20 }} />
      )}

      <div className="wizard-info-box" style={{ marginTop: 24 }}>
        <p>
          <InfoCircleOutlined style={{ marginRight: 8 }} />
          Discount codes are optional. You can add them later if needed.
        </p>
      </div>
    </div>
  );
};

export default Step2CheckoutSettings;
